import { useCallback } from 'react';
import isNil from 'lodash/isNil';

import {
  UniversalFilterCheckboxValue,
  UniversalFilterCheckboxFilterState,
  UniversalFilterCheckboxOnChange
} from '../../UniversalFilterCheckbox.types';

interface UniversalFilterCheckboxFilterStateOptions {
  onChange: UniversalFilterCheckboxOnChange;
}

function useUniversalFilterCheckboxFilterState({
  onChange
}: UniversalFilterCheckboxFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterCheckboxFilterState) => void
  >(
    (filterState) => {
      if (filterState.value) {
        onChange(true);
      } else {
        onChange();
      }
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterCheckboxValue
    ) => UniversalFilterCheckboxFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (filterValue === true) {
      return { value: true };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterCheckboxFilterState;
